import type { ShortCarModelSource } from './short-car-model.types';

const SHORT_CAR_MODEL_SOURCE_FIELDS = [
  'carModel',
  'carModelAndBrand',
  'carBrandName',
  'carName',
] as const;

export const SHORT_CAR_MODEL_MAXIMUM_CHARS = 120;

export function hasShortCarModelSourceData(
  source: ShortCarModelSource,
): boolean {
  return SHORT_CAR_MODEL_SOURCE_FIELDS.some(field => Boolean(source[field]));
}

export function requiresShortCarModelCalculation(
  source: ShortCarModelSource,
): boolean {
  return SHORT_CAR_MODEL_SOURCE_FIELDS.some(field => {
    const value = source[field];

    return Boolean(value && value.length > SHORT_CAR_MODEL_MAXIMUM_CHARS);
  });
}
